/**
* 基础菜单 代发详情
*/
<template>
  <div class="contianer">
    <div v-if="detailData.length&&isGetData">
      <el-tabs v-model="activeName" @tab-click="handleClick">
<!--        <el-tab-pane :label="detail.delivery_name=='自提'?'自提':'快递号'+detail.delivery_no" :name="detail.id" v-for="(detail,index) in detailData" :key="index">-->
        <el-tab-pane :label="detail.order_code" :name="detail.id" v-for="(detail,index) in detailData" :key="index">
          <div class="flex_box" style="margin-top: 15px">
            <div class="order_no item f15">
              <p class="color333">代发单号</p>
              <span class="color666">{{detail.order_code}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="item f15">
              <p class="color333">供应商</p>
              <span class="color666">{{detail.seller_name}}</span>
            </div>
          </div>
          <!--列表-->
          <div class="mt50">
            <p class="title f20 color333 fontWeight mb20">代发单商品清单</p>
            <el-table size="small" :data="detail.items" highlight-current-row v-loading="loading" border
                      element-loading-text="拼命加载中" style="width: 90%;">
              <el-table-column
                type="index"
                label="序号"
                width="80">
              </el-table-column>
              <el-table-column prop="product_code" label="商品编码" min-width="200" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_sale_name" label="销售名称" width="300" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="brand_name" label="商品品牌" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="model" label="商品包装规格" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_num" label="数量" width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="sale_price" label="供货价" width="150" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.sale_price}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="total_sale_price" label="小计" width="150" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div>￥{{scope.row.total_sale_price}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
<!--    <div v-if="!detailData.length&&isGetData" class="noData-box">-->
<!--      <img src="/static/img/noData.png" alt="">-->
<!--    </div>-->
  </div>
</template>

<script>
import {
  agentDetail,
  sendRecord,
} from '../../api/basisMG'

  export default {
    data: () => {
      return {
        activeName: '0',
        loading: false, //是显示加载
        detailData: {},
        productData: [],
        id:'',
        delivery_no:'',
        send_record_id:'',
        delivery_com_id: '',
        delivery_name: '',
        isGetData:false,
        sendRecordId: '',
        comId: ''
      }
    },
    // 注册组件
    components: {},
    /**
     * 创建完毕
     */
    created() {
      this.id = this.$route.query.id;
      this.currentPage = 1;
      if (this.$route.query.id) {
        localStorage.setItem('orderId', this.$route.query.id)
        this.getdata(this.$route.query.id)
      }
    },
    mounted() {
      if (!this.id) {
        this.getdata(localStorage.getItem('orderId'))
      }
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(id) {
        this.loading = true
        agentDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailData = res.content;
              this.isGetData = true;
              if(res.content){
                this.activeName = res.content[0].id;
                this.productData = res.content.items;
                this.sendRecordId = res.content[0].id;
              };
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .textCenter {
    text-align: center;
  }

  .mt50 {
    margin-top: 50px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .mr12 {
    margin-right: 12px;
  }

  .f12 {
    font-size: 12px;
  }

  .f14 {
    font-size: 14px;
  }

  .f15 {
    font-size: 15px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .item {
    margin-right: 50px;
    margin-bottom: 15px;
  }

  .item .color333 {
    margin-right: 12px;
  }

  .item p {
    display: inline-block;
  }

  .w120 {
    width: 120px;
  }

  .lh32 {
    line-height: 32px;
  }

  .lh40 {
    line-height: 40px;
  }

  .noData-box {
    height: calc(100vh - 220px);
  }
  .noData-box img{
    width: 650px;
    height: 398px;
    margin-top: 150px;
    margin-left: 150px;
  }
  .edit {
    width: 14px;
    height: 14px;
    margin-left: 12px;
    cursor: pointer;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-input--small {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 15%;
  }

  .bfore :before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

</style>





// WEBPACK FOOTER //
// src/views/order/proxyDetails.vue